<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('reports.clientsWOrders')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="sales-report">
    <!-- Sales Report -->
      <div class="col-md-12">
          <div class="pull-left mar-rt-10" v-if="showLocations">
            <span class="pad-rg-5">{{$t('dashboard.selectLocation')}}</span>
            <select class="form-control inline-auto white " v-model="products.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option
                  :label="loc.name"
                  :value="loc.id"
                  > {{loc.name}}
                </option>
              </template>
            </select>
          </div>
          <div class="pull-left mar-rt-10">
            <v-select v-model="topCategorySelected"
              multiple
              :options="category"
              value="name"
              label="name"
              :ref="'name'"
              :placeholder="$t('general.all')"
              class=""
              v-on:input="resetCategorySelect"
              :key="'name'">
              </v-select>
          </div>
          <div class="pull-left mar-rt-10">
            <v-select v-model="categorySelected"
              multiple
              :options="allCategories"
              value="name"
              label="name"
              :ref="'name'"
              :placeholder="$t('general.all')"
              class=""
              :key="'name'">
              </v-select>
          </div>
          <p :class="{'pull-left': true, 'sales-rectify-date-picker-padding': !showLocations}">
            <el-date-picker
              type="daterange"
              v-model="products.valid"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :name="pickerNames"
              :picker-options="pickerOptions">
            </el-date-picker>
          </p>
          <div class="pull-left search-button-reports">
            <div class="btn btn-icon btn-info btn-search" @click="updateData" :title="$t('reports.search')"><i class="ti-search"></i></div>
            <!--  -->
          </div>
          <div class="pull-right search-button-reports" :title="$t('reports.export')">
            <download-excel
              v-if="this.$route.query && this.$route.query.ver !== 'V2'"
              class   = "btn btn-icon btn-xls"
              :data   = "json_data"
              :export-fields = "jsonFields"
              :name    = "export_name">
              {{$t('general.download_xls') }} <img src="/static/img/export_xls.png">
            </download-excel>
            <download-excel
              v-if="this.$route.query && this.$route.query.ver !== 'V2'"
              class   = "btn btn-icon mar-rt-40 btn-xls"
              :data   = "custom_json_data"
              :export-fields = "customJsonFields"
              :name    = "export_name">
              {{$t('general.download_xls')}} {{$t('general.detail')}}<img src="/static/img/export_xls.png">
            </download-excel>
            <download-excel
              v-if="this.$route.query && this.$route.query.ver === 'V2'"
              class   = "btn btn-icon mar-rt-40 btn-xls"
              :fetch   = "productExportData"
              :fields = "jsonFieldsV2"
              :name    = "export_name"
              :before-generate = "startDownload"
              :before-finish   = "finishDownload">
              {{$t('general.download_xls') }} <img src="/static/img/export_xls.png">
            </download-excel>
          </div>
      </div>
      <div class="col-md-12">
        <h5 class="pad-bt-10 mar-to-15 display-flex justify-space-evenly"><span>{{$t('reports.totalProducts')}}: {{ totalQuantity }}</span> <span>{{$t('reports.totalSum')}}: {{formatMoneyAmount(totalSum.toFixed(2))}}</span></h5>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-content total-pagination">
            <data-tables-server
              @query-change="paginationChanged"
              v-loading="loading"
              :data="productsTableData.data"
              :search-def="{show: false}"
              :total="totalRecords"
              :pagination-props="paginationProps"
              class="remove-row-highlight"
              key="sales-table"
              style="width: 100%"
              ref="reportsProductsTable">
              <el-table-column :min-width="100" prop="name" :label="$t('reports.name')" />
              <el-table-column :min-width="80" prop="qty" :label="$t('reports.quantity')" />
              <el-table-column :min-width="70" prop="price" :label="$t('reports.pricePerUnit')" >
                <template slot-scope="props">
                  <b>{{formatMoneyAmount(props.row.price)}}</b>
                </template>
              </el-table-column>
              <el-table-column :min-width="80" prop="total_sales_value" :label="$t('reports.totalSum')">
                <template slot-scope="props">
                  <b>{{formatMoneyAmount(props.row.total_sales_value)}}</b>
                </template>
              </el-table-column>
            </data-tables-server>
          </div>
        </div>
      </div>
    </div>
    <!-- END Sales Report -->
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import moment from 'moment'
import JsonExcel from 'vue-json-excel'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    // GeneralTopBar,
    [DatePicker.name]: DatePicker
  },
  props: {
    isProductSales: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isProductSales () {
      if (this.isProductSales) {
        this.getProducts()
      }
    }
  },
  created () {
    const currentDate = new Date()
    const formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear()
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '_' + this.$t('reports.productsSalesReport') + '_' + formattedDate + '.xls'
    this.verifyUserLocations()
  },
  data () {
    return {
      loading: true,
      category: [],
      topCategorySelected: [],
      categorySelected: [],
      allCategories: [],
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      products: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().endOf('month').format('YYYY-MM-DD')
        ],
        location: ''
      },
      locations: [],
      showLocations: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      productsTableData: {},
      totalRecords: null,
      totalQuantity: null,
      jsonFields: {
        [this.$t('reports.productName')]: 'name',
        [this.$t('reports.quantity')]: 'qty',
        [this.$t('reports.pricePerUnit')]: 'price_per_unit',
        [this.$t('reports.totalSum')]: 'total_sales_value'
      },
      customJsonFields: {
        'Order ID': 'order_id',
        'Order Number': 'order_number',
        'Client': 'client',
        'Telefon': 'phone',
        'Adresa': 'address',
        'Comentariu': 'comment',
        'Produs': 'product_name',
        'Cantitate': 'product_qty',
        'Pret Net': 'product_price',
        'Nr Bon': 'receipt_number'
      },
      jsonFieldsV2: {
        [this.$t('reports.productName')]: 'name',
        [this.$t('reports.quantity')]: 'qty',
        [this.$t('reports.pricePerUnit')]: 'price',
        [this.$t('reports.totalSum')]: 'total_sales_value'
      },
      export_name: '',
      json_data: [],
      custom_json_data: [],
      totalSum: 0
    }
  },
  methods: {
    async productExportData () {
      let resp = []
      if (this.totalQuantity) {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          start_date: this.products.valid[0],
          end_date: this.products.valid[1],
          categorySelected: this.categorySelected,
          topCategorySelected: this.topCategorySelected
        }

        let productSalesData = []
        resp = await new Promise((resolve, reject) => {
          const ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : ''
          this.apiRequest('/reports/products-sales-report' + ver + '?withProducts=1&page=' + 1 + '&pageSize=' + 50000, 'GET', data, response => {
            productSalesData = response.data.products.data
            if (productSalesData) {
              this.json_data = response.data.export_excel
              this.totalSum = response.data.total_sum
              this.totalRecords = response.data.total
              this.category = response.data.category
              this.totalQuantity = response.data.total_quantity
            }
            resolve(productSalesData)
          })
        })
        return resp
      }
    },
    startDownload () {
      this.loading = true
    },
    finishDownload () {
      this.loading = false
    },
    resetCategorySelect () {
      this.categorySelected = []
      this.allCategories = []
      this.topCategorySelected.forEach((element) => {
        element.category.forEach((el) => {
          this.allCategories.push(el)
        })
      })
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getProducts(query)
      if (query.type === 'size') this.getProducts(query)
      if (query.type === 'sort') this.getProducts(query)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details
      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }
      if (this.locations.length > 1) {
        this.showLocations = true
        let filterCookie = this.$cookie.get('filter-locations')
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie)
          this.products.location = filterCookie[0]
        }
      }
    },
    getProducts (query) {
      if (!this.isProductSales) {
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.products.valid[0],
        end_date: this.products.valid[1],
        categorySelected: this.categorySelected,
        topCategorySelected: this.topCategorySelected
      }
      if (this.products.location && this.products.location !== '') {
        data.location_id = this.products.location
      }
      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      const ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : ''
      this.apiRequest('/reports/products-sales-report' + ver + '?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
        if (response.status === true) {
          this.productsTableData = response.data.products
          this.json_data = response.data.export_excel
          this.custom_json_data = response.data.export_custom_excel
          this.totalSum = response.data.total_sum
          this.totalRecords = response.data.total
          this.category = response.data.category
          this.totalQuantity = response.data.total_quantity
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getProducts()
      this.$cookie.set('filter-locations', JSON.stringify([this.products.location]), 30)
    },
    goToRecordOrder (row, event, column) {
      window.open(`/#/products/edit/${row.id}`)
    },
    daysBetween (date1, date2) {
      var oneDay = 1000 * 60 * 60 * 24
      var date1Ms = date1.getTime()
      var date2Ms = date2.getTime()
      var differenceMs = date2Ms - date1Ms
      return Math.round(differenceMs / oneDay)
    },
    firstDayofMonth () {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
      return firstDay
    },
    lastDayofMonth () {
      var date = new Date()
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return lastDay
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    tabClicked (selectedTab) {
      // console.warn('test')
      // console.warn('Current tab re-clicked:' + selectedTab.tab.title)
    },
    tabChanged (selectedTab) {
      // console.warn('Tab changed to:' + selectedTab.tab.title)
    }
  }
}
</script>
<style>
  .dropdown.v-select.searchable {
    background: #fff;
  }
  .v-select .selected-tag {
    margin-top: 6px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ProductsSales.vue